// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"c718f10e","491":"cf0bca77","500":"fb61762a","577":"9f14e062","647":"d6865e90","904":"729013ad","990":"9fb588c0"}[chunkId] + ".chunk.js";
};